import { useHistory } from 'react-router';
import { useGTMDataLayer } from '../../../hooks/GTM/useGTMDataLayer';

export const createHandleLoginClick =
  (
    dataLayer: ReturnType<typeof useGTMDataLayer>,
    history: ReturnType<typeof useHistory>,
    loginWithRedirect: (options: { appState: { returnTo: string } }) => Promise<void>,
  ) =>
  () => {
    dataLayer?.push({
      event: 'cta_click',
      cta_text: 'Logg inn for å få kampanjekode',
      cta_location: history.location.pathname,
      cta_position: 'content',
    });
    loginWithRedirect({
      appState: {
        returnTo: `${window.location.origin}${history.location.pathname}`,
      },
    });
  };
